import {
	AtomicMoveMutation,
	CreateMovementOrderMutation,
	ReceiveMovementOrderMutation,
	ShipMovementOrderMutation
} from "~/gql/mutations/movementOrder.generated";
import {
	GetMovementOrderTransactionsByLocationQuery,
	GetPendingTransferOrdersByDestinationQuery
} from "~/gql/queries/movementOrder.generated";

export const movementOrderEndpoints = {
	AtomicMove: {
		invalidatesTags: [
			"MaterialItemLocationQuantities",
			"MaterialTransactions",
			"MovementOrderTransactions"
		] as AddTagTypes,
		transformResponse: (res: AtomicMoveMutation) => res
	},
	CreateMovementOrder: {
		invalidatesTags: ["PendingTransferOrders", "MovementOrderTransactions"] as AddTagTypes,
		transformResponse: (res: CreateMovementOrderMutation) => res
	},
	GetMovementOrderTransactionsByLocation: {
		providesTags: ["MovementOrderTransactions"] as AddTagTypes,
		transformResponse: (res: GetMovementOrderTransactionsByLocationQuery) => res
	},
	GetPendingTransferOrdersByDestination: {
		providesTags: ["PendingTransferOrders"] as AddTagTypes,
		transformResponse: (res: GetPendingTransferOrdersByDestinationQuery) => res
	},
	ReceiveMovementOrder: {
		invalidatesTags: [
			"MaterialItemLocationQuantities",
			"MaterialTransactions",
			"PendingTransferOrders",
			"MovementOrderTransactions"
		] as AddTagTypes,
		transformResponse: (res: ReceiveMovementOrderMutation) => res
	},
	ShipMovementOrder: {
		invalidatesTags: [
			"MaterialItemLocationQuantities",
			"MaterialTransactions",
			"PendingTransferOrders",
			"MovementOrderTransactions"
		] as AddTagTypes,
		transformResponse: (res: ShipMovementOrderMutation) => res
	}
};
